export default __webpack_public_path__ + "static/media/stacking.86bf14da.png";